import React, { useState } from "react";
import { Modal, List, Avatar, Tag, Typography, Empty, Spin } from "antd";
import { useItemsFine } from "../../../_actions/app/items";
import { getPublicImageURL } from "../../../_helpers/image";

const { Text } = Typography;

function ProductSelector({ trigger, onSelect }) {
    const [open, setOpen] = useState(false);

    const { isLoading, isSuccess, data } = useItemsFine(
        "qdb_product",
        ``,
        open,
    );

    const handleSelect = (item) => {
        onSelect?.(item);
        setOpen(false);
    };

    return (
        <>
            <span onClick={() => setOpen(true)}>{trigger}</span>
            <Modal
                open={open}
                onCancel={() => setOpen(false)}
                title="Select Product"
                footer={null}
                width={520}
            >
                {isLoading && (
                    <div style={{ textAlign: "center", padding: "40px 0" }}>
                        <Spin />
                    </div>
                )}

                {isSuccess && data?.length === 0 && (
                    <Empty description="No products found" />
                )}

                {isSuccess && data?.length > 0 && (
                    <List
                        dataSource={data}
                        renderItem={(item) => (
                            <List.Item
                                onClick={() => handleSelect(item)}
                                style={{
                                    cursor: "pointer",
                                    padding: "10px 12px",
                                    borderRadius: "8px",
                                    transition: "background 0.15s",
                                }}
                                onMouseEnter={(e) =>
                                    (e.currentTarget.style.background =
                                        "#f5f5f5")
                                }
                                onMouseLeave={(e) =>
                                    (e.currentTarget.style.background =
                                        "transparent")
                                }
                            >
                                <List.Item.Meta
                                    avatar={
                                        <Avatar
                                            src={getPublicImageURL(
                                                item.main_image,
                                            )}
                                            size={56}
                                            shape="square"
                                            style={{
                                                objectFit: "contain",
                                                border: "1px solid #f0f0f0",
                                                borderRadius: "6px",
                                                flexShrink: 0,
                                            }}
                                        />
                                    }
                                    title={
                                        <Text
                                            strong
                                            style={{ fontSize: "0.95rem" }}
                                        >
                                            {item.name}
                                        </Text>
                                    }
                                    description={
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: "2px",
                                            }}
                                        >
                                            {item.description && (
                                                <Text
                                                    type="secondary"
                                                    style={{
                                                        fontSize: "0.8rem",
                                                    }}
                                                    ellipsis={{
                                                        tooltip:
                                                            item.description,
                                                    }}
                                                >
                                                    {item.description}
                                                </Text>
                                            )}
                                            <div
                                                style={{
                                                    display: "flex",
                                                    gap: "6px",
                                                    alignItems: "center",
                                                    marginTop: "2px",
                                                }}
                                            >
                                                {item.price != null && (
                                                    <Tag
                                                        color="green"
                                                        style={{ margin: 0 }}
                                                    >
                                                        ₹{item.price}
                                                    </Tag>
                                                )}
                                                {item.key_highlights && (
                                                    <Text
                                                        type="secondary"
                                                        style={{
                                                            fontSize: "0.75rem",
                                                        }}
                                                        ellipsis
                                                    >
                                                        {item.key_highlights}
                                                    </Text>
                                                )}
                                            </div>
                                        </div>
                                    }
                                />
                            </List.Item>
                        )}
                    />
                )}
            </Modal>
        </>
    );
}

export default ProductSelector;
